/** VSlider registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseVSlider } from './parser';
const vSliderRegistration = {
    typeName: 'VSlider',
    parser: parseVSlider,
};
nodeRegistry.register(vSliderRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map